import { ca } from '@cian/analytics';

export function trackHelpDealRentTrapClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'click',
    label: 'helpDealRentTrap',
  });
}
